module.exports = __webpack_public_path__ + "img/file_info_statistics.c5e1a2e8.png";